export interface ExecutiveProfile {
  id: number;
  name: string;
  role: string;
  image: string;
  bio: string;
  slug: string;
  number: string;
  focus: string[];
}

export const executivesData: ExecutiveProfile[] = [
  {
    id: 1,
    number: "01",
    name: "RICARDO CASTILLO",
    role: "Superintendente Nacional",
    image: "https://acadcr.org/wp-content/uploads/2026/08/pricrado3.jpeg?v=nggg5zhabn",
    bio: "Servidor con más de 20 años de trayectoria pastoral y liderazgo ministerial.",
    slug: "perfil-ejecutivo-ricardo-castillo",
    focus: ["Visión nacional", "Acompañamiento pastoral", "Liderazgo ministerial"],
  },
  {
    id: 2,
    number: "02",
    name: "CELENIA MURILLO",
    role: "Vice-Superintendente",
    image: "https://acadcr.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-26-at-9.20.39-PM-1.jpeg?v=qlkkaob3ssp",
    bio: "Supervisando el crecimiento de las regiones y brindando apoyo directo a los distritos.",
    slug: "perfil-ejecutivo-celenia-murillo",
    focus: ["Apoyo al Ejecutivo", "Crecimiento regional", "Acompañamiento distrital"],
  },
  {
    id: 3,
    number: "03",
    name: "AUREA ORDÓÑEZ",
    role: "Secretaria Nacional",
    image: "https://acadcr.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-26-at-9.20.39-PM-3.jpeg?v=nis5ceh84wk",
    bio: "Encargada del desarrollo administrativo, la correspondencia y la historia institucional.",
    slug: "perfil-ejecutivo-aurea-ordonez",
    focus: ["Administración institucional", "Correspondencia nacional", "Memoria histórica"],
  },
  {
    id: 4,
    number: "04",
    name: "LUIS VARGAS",
    role: "Tesorero Nacional",
    image: "https://acadcr.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-26-at-9.20.40-PM-2.jpeg?v=e6hi5wgxnle",
    bio: "Administración responsable y transparente de las finanzas y los proyectos nacionales.",
    slug: "perfil-ejecutivo-luis-vargas",
    focus: ["Mayordomía responsable", "Transparencia financiera", "Proyectos nacionales"],
  },
  {
    id: 6,
    number: "05",
    name: "ODILON HERNÁNDEZ",
    role: "Vocal 1",
    image: "https://acadcr.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-26-at-9.20.39-PM.jpeg?v=rrb6jleurm",
    bio: "Asesoría ministerial y acompañamiento a los proyectos especiales del Ejecutivo.",
    slug: "perfil-ejecutivo-odilon-hernandez",
    focus: ["Asesoría ministerial", "Proyectos especiales", "Acompañamiento ejecutivo"],
  },
  {
    id: 7,
    number: "06",
    name: "CALEB RAMÍREZ",
    role: "Vocal 2",
    image: "https://acadcr.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-26-at-9.20.40-PM.jpeg?v=vdyldfu20va",
    bio: "Coordinación y apoyo de los departamentos de formación y desarrollo social.",
    slug: "perfil-ejecutivo-caleb-ramirez",
    focus: ["Formación", "Desarrollo social", "Coordinación departamental"],
  },
  {
    id: 8,
    number: "07",
    name: "EMANUEL BARRIENTOS",
    role: "Vocal 3",
    image: "https://acadcr.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-26-at-9.20.39-PM-2.jpeg?v=5k95w2ufyb5",
    bio: "Supervisión de iniciativas misioneras y plantación de nuevas congregaciones.",
    slug: "perfil-ejecutivo-emanuel-barrientos",
    focus: ["Iniciativas misioneras", "Plantación de iglesias", "Expansión ministerial"],
  },
  {
    id: 5,
    number: "08",
    name: "PATRICIA HERRERA",
    role: "Fiscal Nacional",
    image: "https://acadcr.org/wp-content/uploads/2026/08/WhatsApp-Image-2026-08-26-at-9.20.40-PM-1.jpeg?v=podwyw1efx",
    bio: "Supervisión del cumplimiento legal, normativo y estatutario de la institución.",
    slug: "perfil-ejecutivo-patricia-herrera",
    focus: ["Cumplimiento legal", "Normativa institucional", "Supervisión estatutaria"],
  },
];

export function findExecutiveProfile(slug?: string): ExecutiveProfile {
  const normalized = (slug || "").toLowerCase().replace(/^\/+|\/+$/g, "");
  return executivesData.find((executive) => executive.slug === normalized) || executivesData[0];
}
